export default __webpack_public_path__ + "static/media/Path3526.d7883335.svg";